export interface RenderPdfPayload {
  resource_type: "prescription" | "patient_term" | "prontuario_export";
  resource_id: string;
}

export interface RenderPdfArgs extends RenderPdfPayload {
  /** Supabase access token of the signed-in user. */
  token: string;
}

function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

/** Renders the unsigned PDF in the PDF Lambda (POST /render). Pure: usable outside React. */
export async function renderPdf({ resource_type, resource_id, token }: RenderPdfArgs): Promise<Uint8Array> {
  const lambdaUrl = import.meta.env.VITE_PDF_LAMBDA_URL as string | undefined;
  if (!lambdaUrl) throw new Error("pdf_lambda_url_not_configured");

  const resp = await fetch(`${lambdaUrl.replace(/\/$/, "")}/render`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ resource_type, resource_id }),
  });
  const json = await resp.json().catch(() => null);
  if (!resp.ok || !json?.success || !json?.pdf_base64) throw new Error(json?.error ?? "unknown_error");
  return base64ToBytes(json.pdf_base64 as string);
}
